// TO BE DELETED when 36413 pushed in prod and service-page renamed to
page-service in Storyblok
<template>
  <PageService :blok="blok" :context="context" />
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  context: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});
</script>
